import { getImagesByQuery } from "./js/pixabay-api.js";
import * as render from './js/render-functions.js';
import iziToast from 'izitoast';
import 'izitoast/dist/css/iziToast.min.css';

const form = document.querySelector('.form');
const loadMoreBtn = document.querySelector('.load-more');

let searchQuery = '';
let page = 1;
let totalHits = 0;
const perPage = 15;

form.addEventListener('submit', async (event) => {
  event.preventDefault();

  searchQuery = event.currentTarget.elements.query.value.trim();
  if (!searchQuery) {
    iziToast.warning({
      title: 'Caution',
      message: 'Please enter a search term',
    });
    return;
  }

  page = 1;
  render.clearGallery();
  render.hideLoadMoreButton();
  render.showLoader();

  try {
    const data = await getImagesByQuery(searchQuery, page);
    totalHits = data.totalHits;

    if (data.hits.length === 0) {
      iziToast.error({
        message: 'Sorry, there are no images matching your search query.',
      });
      return;
    }

    render.createGallery(data.hits);

    const totalPages = Math.ceil(totalHits / perPage);

    if (totalPages > 1) {
      render.showLoadMoreButton();
    } else {
      iziToast.info({
        message: "We're sorry, but you've reached the end of search results.",
      });
    }
  } catch (error) {
    iziToast.error({
      title: 'Error',
      message: 'Something went wrong!',
    });
  } finally {
    render.hideLoader();
    form.reset();
  }
});

loadMoreBtn.addEventListener('click', async () => {
  page += 1;
  render.hideLoadMoreButton();
  render.showLoader();

  try {
    const data = await getImagesByQuery(searchQuery, page);
    render.createGallery(data.hits);

    const card = document.querySelector('.gallery-item');
    const rect = card.getBoundingClientRect();
    window.scrollBy({
      top: rect.height * 2,
      behavior: 'smooth',
    });

    const totalPages = Math.ceil(totalHits / perPage);

    if (page >= totalPages) {
      render.hideLoadMoreButton();
      iziToast.info({
        message: "We're sorry, but you've reached the end of search results.",
      });
    } else {
      render.showLoadMoreButton();
    }
  } catch (error) {
    iziToast.error({ message: 'Error fetching more images' });
  } finally {
    render.hideLoader();
  }
});
